// -------------- SERVICE Page --------------
export const FIXTURE_FIELD_ERROR       = 'FIXTURE_FIELD_ERROR';
export const FIXTURE_FIELD_RESET_ERROR = 'FIXTURE_FIELD_RESET_ERROR';
export const FIXTURE_GET_ITEM          = 'FIXTURE_GET_ITEM';
export const FIXTURE_SET_ITEM          = 'FIXTURE_SET_ITEM';
export const FIXTURE_SET_ALL           = 'FIXTURE_SET_ALL';
export const FIXTURE_ADD_ITEM          = 'FIXTURE_ADD_ITEM';



// --------- FIXTURE Page ---------
export function fixtureFieldError(field, fieldData = {}) {
    return { type: FIXTURE_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function fixtureFieldResetError(field, fieldData = {}) {
    return { type: FIXTURE_FIELD_RESET_ERROR }
}
export function fixtureSetItem(targetItem) {
    return { type: FIXTURE_SET_ITEM, data: targetItem }
}
export function fixtureGetItem(targetItem) {
    return { type: FIXTURE_GET_ITEM, data: targetItem }
}
export function fixtureAddItem(addItem) {
    return { type: FIXTURE_ADD_ITEM, data: addItem }
}
export function fixtureSetList(allSERVICE) {
    return { type: FIXTURE_SET_ALL, data: allSERVICE }
}
